<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic"
  class="tw-w-full"
>
  <mat-select
    id="resolutionSelect"
    [(ngModel)]="resolutionOption"
    (selectionChange)="updateResolution()"
    aria-labelledby="resolutionLabel"
  >
    @for (key of objectKeys(resolutionOptions); track key) {
      <mat-option [value]="key">{{ resolutionOptions[key] }}</mat-option>
    }
  </mat-select>
</mat-form-field>
@if (resolutionOption === 'custom') {
  <div id="customResolution" class="animated fadeIn u_margin-sm-top">
    <div class="row sm-gutter">
      <div class="col-sm-6">
        <label id="widthLabel" class="control-label">Width:</label>
        <div class="input-group">
          <input
            #widthInput="ngModel"
            name="width"
            id="widthInput"
            class="form-control"
            type="number"
            [(ngModel)]="width"
            (ngModelChange)="widthChange.emit(width)"
          />
          <span id="widthPxLabel" class="input-group-addon">px</span>
        </div>
      </div>
      <div class="col-sm-6">
        <label id="heightLabel" class="control-label">Height:</label>
        <div class="input-group">
          <input
            #heightInput="ngModel"
            name="height"
            id="heightInput"
            class="form-control"
            type="number"
            [(ngModel)]="height"
            (ngModelChange)="heightChange.emit(height)"
          />
          <span id="heightPxLabel" class="input-group-addon">px</span>
        </div>
      </div>
    </div>
  </div>
}
